<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
   <div>
      <Breadcrumbs main="Vehicles" title="Sold Vehicles" />

      <div class="container-fluid">
         <div class="row">
            <div class="col-sm-12">
               <div class="card">
                  <div class="card-body">

                     <div class="col-md-12 project-list page-subtitle">
                           <div class="row">
                              <div class="col-md-10 d-flex">
                                 <span style="font-size: 20px; font-weight: bolder;">Sold Vehicles</span>
                              </div>
                              <div class="col-md-2">
                                 <!-- <router-link :to="{ name: 'users.adduser' }" class="btn btn-primary">Add User</router-link> -->
                                 <router-link :to="{ name: 'addvehicle' }" class="btn btn-primary">Add Vehicle</router-link>
                              </div>
                                 
                           </div>
                     </div>

                     <div class="col-md-12 project-list filter-sort">
                        <div class="row">
                           <div class="col-md-9 d-flex">
                              <label class="d-flex listing-length">
                                 <span>Show</span>
                                 <select class="form-select"  v-model="sold_listing_length" @change="fetchSoldVehicles()">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                 </select>
                                 <span>entries</span>
                              </label>
                           </div>
                                    
                           <div class="col-md-3">
                                 <input type="text" class="form-control" placeholder="Search" v-model="sold_keyword" @keyup="fetchSoldVehicles()"/>
                           </div>
                        </div>
                     </div>

                        <div class="table-responsive product-table">
                           <table class="display" id="basic-1">
                              <thead>
                                 <tr>
                                    <th>Image</th>
                                    <th>Title</th>
                                    <th>Price</th>
                                    <th>Status</th>
                                    <th>Options</th>
                                 </tr>
                              </thead>
                              <tbody v-if="Boolean(sold_vehicles.length)">
                                 <tr v-for="sold in sold_vehicles" :key="sold.id">
                                    <td><img v-if="sold.image" :src="$image_url + sold.image" alt="Image not found" style="width:100px"></td>
                                    <td>{{sold.title}}</td>
                                    <td>Rs. {{sold.price}}</td>
                                    <td>
                                       
                                       <label v-if="sold.status==0">Blocked</label>
                                       <label v-if="sold.status==1">Active</label>
                                       <label v-if="sold.status==2">Requested</label>
                                       <label v-if="sold.status==3">Rejected</label>
                                       <label v-if="sold.status==4">Sold</label>
                                       
                                    </td>
                                    <td>
                                       <router-link :to="{name: 'vehicles.show', params: { id: sold.id }}" class="btn btn-sm btn-primary mt-2 me-1" >View</router-link>


                                       <a href="#" class="btn btn-sm btn-primary mt-2 me-1" @click.prevent="setBackURL(sold.id)">{{sold.clicks}} Clicks <i class="fa fa-angle-double-right"></i></a>
                                       

                                       <a class="btn btn-danger mt-2 me-1 btn-sm" @click="deactivateVehicle(sold)" v-if="sold.status==1">Deactivate</a>
                                       <a class="btn btn-success mt-2 me-1 btn-sm" @click="activateVehicle(sold)" v-if="sold.status==0">Activate</a>                                   
                                    </td>
                                 </tr>
                              </tbody>
                              <tbody v-else>
                                 <tr>
                                    <td colspan="7" class="text-center">No data</td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>

                        <!----pagination starts --->
                        <nav aria-label="Page navigation" class="mt-2">                    
                           <ul class="pagination">
                              <li class="page-item" v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in sold_pagination" :key="page.label">
                                 <a class="page-link" href="#" @click.prevent="fetchSoldVehicles(page.url + '&limit='+ sold_listing_length + '&keyword=' + sold_keyword )" tabindex="-1">
                                    <span v-if="index == 0">Prev</span>
                                    <span v-else-if="index == sold_pagination.length-1">Next</span>
                                    <span v-else>{{page.label}}</span>
                                 </a>
                              </li>                        
                           </ul>
                        </nav>
                        <!----pagination ends --->

                  </div>
               </div>
            </div>
         </div>
      </div>


     
  </div>
</template>


<!-- <template>
   <b-container fluid>
      
       <b-row>
          <b-col sm="12">
               <card>
                  <template v-slot:headerTitle>
                        <h4 class="card-title">Sold Vehicles</h4>
                  </template>
                  <template v-slot:headerAction>
                     <div class="float-right">
                        
                        <router-link :to="{name: 'vehicles.add'}" class="btn btn-primary" >Add Vehicle</router-link>
                     </div>
                  </template>
                  <template v-slot:body>
                     
                     <div class="row">
                        <div class="col-sm-12 col-md-6">
                           <div>
                              <label>Show 
                                 <select class="form-control" v-model="sold_listing_length" @change="fetchSoldVehicles()">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>    
                                 </select> entries
                              </label>
                           </div>
                        </div>
                        <div class="col-sm-12 col-md-6">
                           <div class="div-search">
                              <label>
                                 <input type="text" class="form-control" placeholder="Search" v-model="sold_keyword" @keyup="fetchSoldVehicles()">
                              </label>
                           </div>
                        </div>
                     </div>
                  

                     <div class="table-responsive">
                        <table id="datatable" class="table data-table table-striped table-bordered dataTable" >
                           <thead>
                              <tr>
                                 <th>Image</th>
                                 <th>Title</th>
                                 <th>Price</th>                    
                                 <th>Status</th>
                                 <th>Options</th>                                 
                              </tr>
                           </thead>
                           <tbody>
                              <tr v-for="sold in sold_vehicles" :key="sold.id">
                                 <td><img v-if="sold.image" :src="$image_url + sold.image" alt="Image not found" style="width:100px"></td>
                                 <td>{{sold.title}}</td>
                                 <td>Rs. {{sold.price}}</td>
                                 <td>
                                    
                                    <label v-if="sold.status==0">Blocked</label>
                                    <label v-if="sold.status==1">Active</label>
                                    <label v-if="sold.status==2">Requested</label>
                                    <label v-if="sold.status==3">Rejected</label>
                                    <label v-if="sold.status==4">Sold</label>
                                    
                                 </td>
                                 <td>
                                    <router-link :to="{name: 'vehicles.show', params: { id: sold.id }}" class="btn btn-sm btn-primary mt-2 me-1" >View</router-link>


                                    <a href="#" class="btn btn-sm btn-primary mt-2 me-1" @click.prevent="setBackURL(sold.id)">{{sold.clicks}} Clicks <i class="fas fa-angle-double-right"></i></a>
                                     

                                    <b-button variant="danger" class="mt-2 me-1 btn-sm" @click="deactivateVehicle(sold)" v-if="sold.status==1">Deactivate</b-button>
                                    <b-button variant="success" class="mt-2 me-1 btn-sm" @click="activateVehicle(sold)" v-if="sold.status==0">Activate</b-button>                                   
                                 </td>
                              </tr>
                           </tbody>                           
                        </table>
                     </div>
                     
                     <nav aria-label="Page navigation">                    
                        <ul class="pagination">
                           <li class="page-item" v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in sold_pagination" :key="page.label">
                              <a class="page-link" href="#" @click.prevent="fetchSoldVehicles(page.url + '&limit='+ sold_listing_length + '&keyword=' + sold_keyword )" tabindex="-1">
                                 <span v-if="index == 0">Prev</span>
                                 <span v-else-if="index == sold_pagination.length-1">Next</span>
                                 <span v-else>{{page.label}}</span>
                              </a>
                           </li>                        
                        </ul>
                     </nav>
                              
                  </template>
               </card>
          </b-col>
       </b-row>
               
   </b-container>
</template> -->


<script>
export default {
   name:'SoldVehicles',
   data() {
      return {
         
         sold_vehicles: [],        
         sold_pagination: {},
         edit: false,
         vehicle_status: {
            id: "",
            status: ""
         },
         
         sold_keyword: '',
         sold_listing_length: 10,
         token: '',
         errors: {},
         active_page_url: null,
         active_tab: 0,
      };
   },
   mounted () {
      
   },

   created() {
      this.fetchSoldVehicles();

   },

   methods: {      

      fetchSoldVehicles(page_url=null) {
         let url = '/api/admin/vehicles/sold?limit=' + this.sold_listing_length + '&keyword=' + this.sold_keyword;
         page_url = page_url || url;  

         if(localStorage.back_url) {
            page_url = localStorage.back_url;  
                     
            localStorage.removeItem('back_url');
         }    
         
         this.active_page_url = page_url;   
         this.getToken();
         this.$axios
            .get(page_url,{headers: {Authorization: 'Bearer ' + this.token,}})
            .then(res => {
               var responseData = res.data.data;
               this.sold_vehicles = responseData.data;               
               this.sold_pagination = responseData.links
               
            })
            .catch(err => console.log(err));
      },    

      getToken() {
         if (localStorage.getItem('slo_admin')) {
            var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
            if(slo_admin.token) {
               this.token = slo_admin.token;
               this.user = slo_admin;

            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "Login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "Login" });
         }
      },

      setBackURL(vehicle_id) {
         localStorage.setItem('back_url', this.active_page_url);
         this.$router.push({ name: 'vehicles.clicks', params: { id: vehicle_id } });
      },

      approveVehicle(vehicle) {
         let change_status = false;
         this.$bvModal.msgBoxConfirm('Are you sure you want to approve this ad?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
         })
         .then(value => {
            change_status = value
            if(change_status){
               this.vehicle_status.id = vehicle.id;
               this.vehicle_status.status = '1';
               this.updateVehicleStatus(1);
            }
         })
         .catch(err => {
            console.log(err);
         })
      },
      rejectVehicle(vehicle) {
         let change_status = false;
         this.$bvModal.msgBoxConfirm('Are you sure you want to reject this ad?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
         })
         .then(value => {
            change_status = value
            if(change_status){
               this.vehicle_status.id = vehicle.id;
               this.vehicle_status.status = '3';
               this.updateVehicleStatus(1);
            }
         })
         .catch(err => {
            console.log(err);
         })
      },
      activateVehicle(vehicle) {
         let change_status = false;
         this.$bvModal.msgBoxConfirm('Are you sure you want to activate this ad?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
         })
         .then(value => {
            change_status = value
            if(change_status){
               this.vehicle_status.id = vehicle.id;
               this.vehicle_status.status = '1';
               this.updateVehicleStatus();
            }
         })
         .catch(err => {
            console.log(err);
         })
      },
      deactivateVehicle(vehicle) {
         let change_status = false;
         this.$bvModal.msgBoxConfirm('Are you sure you want to deactivate this ad?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
         })
         .then(value => {
            change_status = value
            if(change_status){
               this.vehicle_status.id = vehicle.id;
               this.vehicle_status.status = '0';
               this.updateVehicleStatus();
            }
         })
         .catch(err => {
            console.log(err);
         })
      },
      updateVehicleStatus(approval = 0) {
         const config = {
              headers: {
                  'Authorization': 'Bearer ' + this.token,
              }
         };
         let url;
         if(approval) {
            url = '/api/admin/vehicles/approve?vehicle_id=';
         } else {
            url = '/api/admin/vehicles/status?vehicle_id=';
         }
         this.$axios
         .get(url + this.vehicle_status.id + '&status=' + this.vehicle_status.status, config)
         .then(response => {
              if(response.data.status) {
                  this.$vToastify.success(response.data.message);
              } else {
                  this.$vToastify.error(response.data.message);
              }
              this.fetchVehicles(this.active_page_url);
          })
          .catch(error => {
               if(error.response){
                  if(error.response.data.message){
                     this.$vToastify.error(error.response.message);
                  } else {
                     this.$vToastify.error("Error!");
                  }                  
               } else {
                  this.$vToastify.error("Error!");
               }
               
          });
      },
   }   
}
</script>